import React from 'react';

import { get } from 'lodash-es';

import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { alpha } from '@mui/material';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { formatDateTimeStringToDateTimeObject } from '@common/Util';

import NewsDialog from './NewsDialog';
import { readNewsHeader, newsImagethumbnailUrl } from './Util';

const StyledCard = styled(Card)(({ theme, props }) => ({
  position: 'relative',
  width: '100%',
  marginBottom: props?.marginBottom,
  marginRight: 0,
  backgroundColor: get(theme.palette.primary, 'background'),
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.background, 0.9)
  },
  [theme.breakpoints.up('md')]: {
    width: props.mediumWidth,
    marginRight: '0.5rem'
  },
  [theme.breakpoints.up('lg')]: {
    width: props?.width,
    marginRight: props?.marginRight
  }
}));

const StyledHeader = styled(Typography)(() => ({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2, // Number of lines
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));

const StyledCardContent = styled(CardContent)(({ props }) => ({
  height: props?.height,
  textAlign: 'left'
}));

const StyledIcon = styled(NewReleasesIcon)(({ theme }) => ({
  color: get(theme.palette.error, 'main'),
  fontSize: '1.8rem',
  position: 'absolute',
  top: '1rem',
  left: '1rem',
  backgroundColor: theme.palette.primary.light,
  borderRadius: '1rem'
}));

const NewsCard = ({
  news,
  style = { width: '345px', mediumWidth: '345px', mb: 0, mr: 0, height: '8rem' },
  memoizedImageSource
}) => {
  return (
    <StyledCard
      props={{
        width: style?.width,
        mediumWidth: style?.mediumWidth,
        marginBottom: style?.mb,
        marginRight: style?.mr,
        isImportant: news?.important
      }}
    >
      {news?.important && <StyledIcon />}
      <CardMedia
        component='img'
        height={170}
        image={newsImagethumbnailUrl(news, memoizedImageSource)}
        alt={readNewsHeader(news)}
        sx={{ padding: '6px', borderRadius: '12px' }}
      />
      <StyledCardContent
        props={{
          height: style?.height
        }}
      >
        <StyledHeader gutterBottom variant='h5' component='div'>
          {readNewsHeader(news)}
        </StyledHeader>
        <Typography variant='body2' sx={{ color: 'text.secondary' }}>
          {formatDateTimeStringToDateTimeObject(news.validFrom)}
        </Typography>
      </StyledCardContent>

      <CardActions>
        <NewsDialog news={news} memoizedImageSource={memoizedImageSource} />
      </CardActions>
    </StyledCard>
  );
};

export default NewsCard;
